// extracted by mini-css-extract-plugin
export default {"container":"src-pages-ProductEditor-VirtualProduct-ProductDetail-Components-SectionWrapper-css-module__container--HLysm"};